// extracted by mini-css-extract-plugin
export default {"paginationWrapper":"TableFooter_paginationWrapper__q+RSu"};